import { render, staticRenderFns } from "./ReferenceModal.vue?vue&type=template&id=076cb8c1&scoped=true"
import script from "./ReferenceModal.vue?vue&type=script&lang=js"
export * from "./ReferenceModal.vue?vue&type=script&lang=js"
import style0 from "./ReferenceModal.vue?vue&type=style&index=0&id=076cb8c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076cb8c1",
  null
  
)

export default component.exports